export default __webpack_public_path__ + "static/media/infrastructure-fund-passcode.17717da8.gif";